import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div style="text-align: justify;">
      
			<p class="mb-3">
				Mi decidis renkonti la Novan jaron sur la ĉefa strato de nia urbo. 
				Tie staras la plej granda Novjara abio, kaj ĉirkaŭ ĝi ĉiam kunvenas gaja homamaso por festi, danci, trinki ĉampanon kaj gratuli tute nekonatajn homojn kiuj hazarde apudis: la festo ja estas por ĉiuj! 
			</p>
			
			<p class="mb-3">
				Sed sur la ĉefa strato troviĝis neniu! La abio pompis kaj brilis, sed eĉ ne unu persono ĝuis la vidaĵon. 
				Nur kiam proksimiĝis meznokto, aperis kelkaj busoj, el kiuj eliris grupoj de viroj vestitaj en nigran uniformon. 
			</p>
			
			<p class="mb-3">
				Mi ekhastis hejmen. 
				Tamen, ne atinginte kelkajn kvartalojn ĝis mia domo, mi ekaŭdis la sonojn de kanonado. 
				Estis interbatalo inter la aro da malgrandaj raketoj kaj la sistemo de kontraŭaera defendo (KAD), kiu pafis al ili. 
				La tuta ĉielo kovriĝis per brilaj strioj de flugantaj eroj, kvazaŭ per festa artfajraĵo.
			</p>
			
			<p class="mb-3">
				Sed mi volas hejmen! Tamen, mia hejmo troviĝas ĝuste tie, kien strebas raketoj kaj kie ilin emas paffaligi KAD. 
				Kaj ajna peco falinta de l’ ĉielo povus trafi min, la solan sur senhoma strato… 
				Jen tiel mi iras poiomete, kaj en la kapo diskutas nur du pensoj:
			</p>
			
			<p class="mb-3">
				– Endas iri hejmen, tie almenaŭ estas tegmento super la kapo, kaj ĝenerale estas azilo, protekto…
			</p>
			
			<p class="mb-3">
				– Sed tie oni pafas!
			</p>
			
			<p class="mb-3">
				– Sed endas ja atingi hejmon!
			</p>
			
			<p class="mb-3">
				– Sed tie ja oni pafas!
			</p>
			
			<p class="mb-5">
				Tiel mi paŝas: jen haltas pro necerteco, jen denove antaŭeniras.
			</p>
			
			<p class="mb-3">
				Sed fine mi atingis hejmon!
			</p>
    </div>
    `
  )
}

const itemName = {
  esp: `La plej kurta kristnaska rakonto`
}

const itemDate = {
	esp: "La 31-a de decembro 2023"
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
		itemDate: itemDate.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;

